'use client'
import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import {Link} from 'react-router-dom'
import {useEventAttendants} from 'organization/Event/Attendants/EventAttendantsProvider'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import PersonIcon from '@mui/icons-material/Person'
import {LocalLink} from 'i18n/LocalLink'
import {useOrganizationEventRoutes} from 'organization/OrganizationRoutes'

const TicketSolds = () => {
  const {t} = useI18n()
  const {attendants, total} = useEventAttendants()
  const routes = useOrganizationEventRoutes()

  return (
    <div className="col-12">
      <div className="card__wrapper p-30">
        {/* Card content */}
        <div className="card__header pb-15">
          <div className="card__header-top d-flex flex-wrap justify-content-between align-items-center gap-2 w-100">
            <div className="card__title-inner">
              <div className="card__header-icon">
                <ConfirmationNumberIcon />
              </div>
              <div className="card__header-title">
                <h4>{t('orgStats.recentAttendeesTitle')}</h4>
              </div>
            </div>
            <div className="ms-auto">
              <LocalLink
                className="btn btn-outline-secondary btn-sm"
                to={routes.attendants}
              >
                {t('eventStats.viewAllAttendees')} ({total})
              </LocalLink>
            </div>
          </div>
        </div>

        <div className="scroll-w-2 card__scrollbar">
          <div className="card__inner">
            {attendants.length === 0 && (
              <div className="tricket__sold-item">
                {t('orgStats.noAttendeesYet')}
              </div>
            )}

            {attendants.length > 0 &&
              attendants.map((attendant, index) => (
                <div key={index} className="tricket__sold-item">
                  <div className="news__item-inner bb-0">
                    <div className="news__content">
                      <h4 className="news__title">
                        <PersonIcon />{' '}
                        <Link to="#">
                          {' '}
                          {attendant.attendee.first_name}{' '}
                          {attendant.attendee.last_name}
                        </Link>
                      </h4>
                      <div className="news__meta">
                        <div className="news__meta-status">
                          <span>
                            <AlternateEmailIcon />
                          </span>
                          <span> {attendant.attendee.email} </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="sold__progress-item">
                    <div className="sold__bar-top">
                      <span>{t('orgStats.ticketNumberLabel')}</span>
                      <span className="devider">:</span>
                      <span className="active">{attendant.id}</span>
                    </div>
                    <div className="sold__bar-top">
                      <span>{t('orgStats.ticketTypeLabel')}</span>
                      <span className="devider">:</span>
                      <span className="active">
                        {attendant.event_ticket?.name ?? '—'}
                      </span>
                    </div>

                    <span className={'status__tag bg-green'}>
                      <span>{t('orgStats.statusActive')}</span>
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketSolds
